import { MenuService } from "@/client";
import { useMutation } from "@tanstack/react-query";

function useUpdateMenuOrder() {
  return useMutation({
    mutationFn: MenuService.updateMenuItemsOrder,
  });
}

export { useUpdateMenuOrder };
